const _serverAddress="http://crematiste63.fr";
const serverIpV4="127.0.0.1";
const mysqlServerPort="7060";
const _sqlServerAddress="";
const mainDb="AssoCrem";
exports.serverAddress=function()
	{
		return _serverAddress;
	}
	exports.ipV4=function()
	{
		return serverIpV4;
	}
	exports.sqlServerAddress=function()
	{
		return _sqlServerAddress;
	}
	exports.sqlServerPort=function()
	{
		return mysqlServerPort;
	}
	exports.sqlServerMainDb=function()
	{
		return mainDb;
	}

